import React from 'react';
import styled from 'styled-components';
import { getSerifMedium } from '@bbc/psammead-styles/font-styles';
import { C_EBON, C_METAL } from '@bbc/psammead-styles/colours';
import { grid } from '@bbc/psammead-styles/detection';
import { getPica } from '@bbc/gel-foundations/typography';
import { GEL_SPACING, GEL_SPACING_DBL } from '@bbc/gel-foundations/spacings';
import { GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_GROUP_2_SCREEN_WIDTH_MAX } from '@bbc/gel-foundations/breakpoints';
import { node, string, shape } from 'prop-types';
import { scriptPropType } from '@bbc/gel-foundations/prop-types';

var getRowCount = function getRowCount(children, columns) {
  return Math.ceil(React.Children.count(children) / columns);
};

export var UsefulLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "UsefulLink",
  componentId: "sc-2b96sp-0"
})(["", ";", ";color:", ";text-decoration:none;&:hover,&:focus{text-decoration:underline;}&:visited{color:", ";}"], function (_ref) {
  var script = _ref.script;
  return script && getPica(script);
}, function (_ref2) {
  var service = _ref2.service;
  return service && getSerifMedium(service);
}, C_EBON, C_METAL);
export var UsefulLinksUl = /*#__PURE__*/styled.ul.attrs({
  role: 'list'
}).withConfig({
  displayName: "UsefulLinksUl",
  componentId: "sc-2b96sp-1"
})(["padding:0;margin:0;list-style-type:none;@media (min-width:", "){column-count:2;column-gap:", ";@supports (", "){display:grid;grid-auto-flow:column;grid-template-columns:repeat(2,1fr);grid-template-rows:repeat( ", ",auto );grid-column-gap:", ";}}"], GEL_GROUP_3_SCREEN_WIDTH_MIN, GEL_SPACING_DBL, grid, function (_ref3) {
  var children = _ref3.children;
  return getRowCount(children, 2);
}, GEL_SPACING_DBL);
export var UsefulLinksLi = /*#__PURE__*/styled.li.attrs({
  role: 'listitem'
}).withConfig({
  displayName: "UsefulLinksLi",
  componentId: "sc-2b96sp-2"
})(["padding-top:", ";@media (max-width:", "){&:first-child{padding-top:0;}}width:100%;@media (min-width:", "){display:inline-block;@supports (", "){display:block;align-self:start;width:initial;}}"], GEL_SPACING, GEL_GROUP_2_SCREEN_WIDTH_MAX, GEL_GROUP_3_SCREEN_WIDTH_MIN, grid);
UsefulLink.propTypes = {
  script: shape(scriptPropType).isRequired,
  service: string.isRequired,
  href: string.isRequired
};
UsefulLinksUl.propTypes = {
  children: node.isRequired
};
UsefulLinksLi.propTypes = {
  children: node.isRequired
};